import React from 'react';

import PropTypes from 'prop-types';

import BaseHeroHeader from 'wanderu-component-hero-header';
import {
    localize,
} from 'wanderu-i18n';

import localesConfig from '../../../config/homepage.locales';

function HeroHeader(props) {
    const {
        t,
    } = props;

    return (
        <BaseHeroHeader
            title={t('baseApp:simplest-way-to-book-bus-and-train-travel')}
            widgetProps={{
                title: t('baseApp:search-widget-title-short'),
            }}
            isHome
        />

    );
}

HeroHeader.propTypes = {
    t: PropTypes.func,
};

export { HeroHeader };
export default localize(HeroHeader, localesConfig.namespace);
